export function normalizeCoupon(value:string){return value.trim().replace(/\s+/g,'').toUpperCase().slice(0,40);}
